<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <!-- Export Dropdown -->
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    v-can="'User.Export'"
                    @click.prevent="exportUsers('pdf')"
                    ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    v-can="'User.Export'"
                    @click.prevent="exportUsers('xlsx')"
                    ><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="mb-2" v-if="authStore.can('User.Create')">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#user_modal"
              v-can="'User.Create'"
              @click="prepareForAdd"
            >
              <i class="ti ti-circle-plus me-2"></i>Add User
            </a>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Users List Table -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Users List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon"
                  ><i class="ti ti-chevron-down"></i
                ></span>
              </div>
            </div>
            <div class="me-3">
              <div class="input-group">
                <input
                  v-model.trim="filters.q"
                  type="text"
                  class="form-control"
                  placeholder="Search name, email, or phone"
                  @keyup.enter="applyFilters"
                />
                <button class="btn btn-primary" type="button" @click="applyFilters">
                  Search
                </button>
              </div>
            </div>
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white"
                data-bs-toggle="dropdown"
                >{{ selectedRoleLabel }}</a
              >
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setRoleFilter('Employee')">Employee</a>
                </li>
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setRoleFilter('Client')">Client</a></li>
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setRoleFilter('Admin')">Admin</a></li>
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setRoleFilter('')">All Roles</a></li>
              </ul>
            </div>
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white"
                data-bs-toggle="dropdown"
                >{{ selectedStatusLabel }}</a
              >
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setStatusFilter('Active')">Active</a></li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setStatusFilter('Inactive')">Inactive</a>
                </li>
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setStatusFilter('')">All Statuses</a></li>
              </ul>
            </div>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white"
                data-bs-toggle="dropdown"
                >{{ selectedSortLabel }}</a
              >
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setSortFilter('recent')">Recently Added</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setSortFilter('asc')">Ascending</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setSortFilter('desc')">Descending</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setPresetRange('lastMonth')">Last Month</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="setPresetRange('last7Days')">Last 7 Days</a>
                </li>
              </ul>
            </div>
            <button class="btn btn-white ms-3" type="button" @click="clearFilters">
              Clear
            </button>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              rowKey="id"
              :columns="columns"
              :data-source="sortedUsers"
              :loading="loading"
              :row-selection="rowSelection"
              @change="handleTableChange"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'first_name'">
                  <div class="d-flex align-items-center file-name-icon">
                    <a
                      href="javascript:void(0);"
                      class="avatar avatar-md avatar-rounded"
                    >
                      <img
                        :src="
                          record.avatar ||
                          require('@/assets/img/users/user-default.png')
                        "
                        class="img-fluid"
                        alt="img"
                      />
                    </a>
                    <div class="ms-2">
                      <h6 class="fw-medium">
                        <a href="javascript:void(0);"
                          >{{ record.first_name }} {{ record.last_name }}</a
                        >
                      </h6>
                      <span class="text-muted">{{ record.email }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="column.key === 'phone'">
                  {{ record.phone }}
                </template>
                <template v-if="column.key === 'role'">
                  <span
                    :class="{
                      'badge-pink-transparent':
                        record.roles?.[0]?.name === 'Employee',
                      'badge-soft-purple': record.roles?.[0]?.name === 'Client',
                      'badge-soft-blue': record.roles?.[0]?.name === 'Admin',

                      // add others as needed
                    }"
                  >
                    {{ record.roles?.[0]?.name || "—" }}
                  </span>
                </template>
                <template v-if="column.key === 'status'">
                  <span
                    class="badge"
                    :class="
                      record.status === 'Active'
                        ? 'badge-success'
                        : 'badge-danger'
                    "
                  >
                    <i class="ti ti-point-filled me-1"></i>{{ record.status }}
                  </span>
                </template>
                <template v-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <!-- <router-link
                      v-if="authStore.can('Permission.Assign')"
                      :to="`/user-management/permissions/${record.id}`"
                      class="me-2"
                    >
                      <i class="ti ti-shield"></i>
                    </router-link> -->
                    <!-- <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#user_modal"
                      @click="prepareForEdit(record)"
                      
                      v-if="authStore.can('User.Edit')"
                    > -->
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#user_modal"
                      @click="prepareForEdit(record)"
                      v-can="'User.Edit'"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      @click="deleteUser(record)"
                      v-can="'User.Delete'"
                    >
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <user-list-modal
    :userData="currentUser"
    :isEditing="isEditing"
    @saved="refreshUserList"
  />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useUserStore } from "@/stores/userStore";
import { useAuthStore } from "@/stores/authStore";
import userReportService from "@/services/userReport.service";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import "daterangepicker/daterangepicker.css";
import UserListModal from "@/components/modal/user-list-modal.vue";
import { toast } from "@/utils/toast";

// Page Info
const title = "Users";
const text = "Administration";
const text1 = "Users";

const userStore = useUserStore();
const authStore = useAuthStore();
const loading = ref(false);
const dateRangeInput = ref(null);
const selectedUsers = ref([]);
const currentUser = ref(null);
const isEditing = ref(false);
const toDeleteUser = ref(null);
const filters = ref({
  role: "",
  status: "",
  q: "",
  date_from: "",
  date_to: "",
  sort: "recent",
});

// Sorting
const sortColumn = ref("");
const sortOrder = ref("ascend");

const columns = [
  {
    title: "Name",
    key: "first_name",
    sorter: true,
    sortOrder: computed(() =>
      sortColumn.value === "first_name" ? sortOrder.value : null
    ),
  },
  // {
  //   title: "Last Name",
  //   key: "last_name",
  //   sorter: true,
  //   sortOrder: computed(() =>
  //     sortColumn.value === "last_name" ? sortOrder.value : null
  //   ),
  // },
  // {
  //   title: "Email",
  //   key: "email",
  //   sorter: true,
  //   sortOrder: computed(() =>
  //     sortColumn.value === "email" ? sortOrder.value : null
  //   ),
  // },
  {
    title: "Phone",
    key: "phone",
    sorter: true,
    // if you want sorting by phone number:
    sorter: {
      compare: (a, b) => a.phone.localeCompare(b.phone),
    },
  },
  {
    title: "Role",
    key: "role",
    sorter: true,
    sortOrder: computed(() =>
      sortColumn.value === "role" ? sortOrder.value : null
    ),
  },
  {
    title: "Status",
    key: "status",
    sorter: true,
    sortOrder: computed(() =>
      sortColumn.value === "status" ? sortOrder.value : null
    ),
  },
  {
    title: "",
    key: "action",
  },
];

// Sorting logic
const sortedUsers = computed(() => {
  let users = [...userStore.users];
  if (sortColumn.value) {
    users.sort((a, b) => {
      let fieldA, fieldB;
      switch (sortColumn.value) {
        case "first_name":
          fieldA = (a.first_name || "").toLowerCase();
          fieldB = (b.first_name || "").toLowerCase();
          break;
        case "last_name":
          fieldA = (a.last_name || "").toLowerCase();
          fieldB = (b.last_name || "").toLowerCase();
          break;
        case "email":
          fieldA = (a.email || "").toLowerCase();
          fieldB = (b.email || "").toLowerCase();
          break;

        case "phone":
          fieldA = (a.phone || "").toLowerCase();
          fieldB = (b.phone || "").toLowerCase();
          break;
        case "role":
          fieldA = (a.roles?.[0]?.name || "").toLowerCase();
          fieldB = (b.roles?.[0]?.name || "").toLowerCase();
          break;

        case "status":
          fieldA = (a.status || "").toLowerCase();
          fieldB = (b.status || "").toLowerCase();
          break;
        default:
          return 0;
      }
      if (fieldA < fieldB) return sortOrder.value === "ascend" ? -1 : 1;
      if (fieldA > fieldB) return sortOrder.value === "ascend" ? 1 : -1;
      return 0;
    });
  }
  return users;
});

const selectedRoleLabel = computed(() =>
  filters.value.role ? `Role : ${filters.value.role}` : "All Roles"
);
const selectedStatusLabel = computed(() =>
  filters.value.status ? `Status : ${filters.value.status}` : "All Statuses"
);
const selectedSortLabel = computed(() => {
  switch (filters.value.sort) {
    case "asc":
      return "Sort By : Ascending";
    case "desc":
      return "Sort By : Descending";
    case "oldest":
      return "Sort By : Oldest";
    default:
      return "Sort By : Recently Added";
  }
});

function buildParams(extra = {}) {
  return {
    ...filters.value,
    ...extra,
  };
}

function handleTableChange(pagination, filters, sorter) {
  if (sorter && sorter.columnKey) {
    sortColumn.value = sorter.columnKey;
    sortOrder.value = sorter.order;
  }
}

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function prepareForAdd() {
  currentUser.value = null;
  isEditing.value = false;
}

function prepareForEdit(user) {
  currentUser.value = { ...user };
  isEditing.value = true;
}

async function refreshUserList() {
  loading.value = true;
  try {
    await userStore.fetchUsers(buildParams(), { force: true });
  } finally {
    loading.value = false;
  }
}

async function ensureUserList() {
  loading.value = true;
  try {
    await userStore.ensureUsers(buildParams());
  } finally {
    loading.value = false;
  }
}

function applyFilters() {
  refreshUserList();
}

function setRoleFilter(role) {
  filters.value.role = role;
  refreshUserList();
}

function setStatusFilter(status) {
  filters.value.status = status;
  refreshUserList();
}

function setSortFilter(sort) {
  filters.value.sort = sort;
  refreshUserList();
}

function setPresetRange(preset) {
  let start;
  let end = moment();
  if (preset === "lastMonth") {
    start = moment().subtract(1, "month").startOf("month");
    end = moment().subtract(1, "month").endOf("month");
  } else {
    start = moment().subtract(6, "days");
  }
  filters.value.date_from = start.format("YYYY-MM-DD");
  filters.value.date_to = end.format("YYYY-MM-DD");
  if (dateRangeInput.value) {
    dateRangeInput.value.value = `${start.format("MM/DD/YYYY")} - ${end.format("MM/DD/YYYY")}`;
  }
  refreshUserList();
}

function clearFilters() {
  filters.value = {
    role: "",
    status: "",
    q: "",
    date_from: "",
    date_to: "",
    sort: "recent",
  };
  if (dateRangeInput.value) {
    dateRangeInput.value.value = "";
  }
  refreshUserList();
}

async function exportUsers(format) {
  try {
    const res = await userReportService.exportReport(format, buildParams());
    const blob = new Blob([res.data], {
      type:
        format === "pdf"
          ? "application/pdf"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = format === "pdf" ? "users-export.pdf" : "users-export.xlsx";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast(error?.response?.data?.message || "Failed to export users.", "error");
  }
}

function deleteUser(user) {
  currentUser.value = user; // CORRECT
}
const rowSelection = {
  onChange: (keys) => (selectedUsers.value = keys),
};

onMounted(() => {
  const start = moment().subtract(6, "days");
  const end = moment();
  filters.value.date_from = start.format("YYYY-MM-DD");
  filters.value.date_to = end.format("YYYY-MM-DD");
  ensureUserList();
  new DateRangePicker(
    dateRangeInput.value,
    {
      startDate: start,
      endDate: end,
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "day"), moment().subtract(1, "day")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
    },
    (start, end) => {
      filters.value.date_from = start.format("YYYY-MM-DD");
      filters.value.date_to = end.format("YYYY-MM-DD");
      refreshUserList();
    }
  );
});
</script>


